import { Grid } from "@mui/material"
import { useEffect } from "react";
import weightIcon from "img/weight_icon.png";
import { useSelector, useDispatch } from 'react-redux'
import { generateWeightChartAllTime, getWeightStatsAllTime } from "redux/reducers/weightReducer";
import SectionHeaderImageIcon from "./SectionHeaderImageIcon";
import { StatsLabels, Dashboard } from "locale/es";
import LineChart from "components/Charts/LineChart";

const WeightStats = () => {
  const dispatch = useDispatch()

  const patientId = useSelector(({ patient }) => patient.id)
  const { allTimeWeightChart, allTimePatientData } = useSelector(({ weightData }) => weightData)

  useEffect(() => {
    if (patientId && !allTimePatientData.data?.length && !allTimePatientData.status) {
      dispatch(getWeightStatsAllTime(patientId))
    }
  }, [patientId, dispatch, allTimePatientData])

  useEffect(() => {
    if (!allTimeWeightChart && allTimePatientData.data?.length && allTimePatientData.status === 200) {
      dispatch(generateWeightChartAllTime(allTimePatientData.data))
    }
  }, [allTimeWeightChart, allTimePatientData])

  return (
    <>
      {allTimeWeightChart &&
        <Grid container justifyContent='center' spacing={2} >
          <SectionHeaderImageIcon icon={weightIcon} sectionTitle={StatsLabels.WEIGHT} />
          <Grid item >
            <LineChart
              dataToShow={allTimeWeightChart}
              title={Dashboard.WEIGHT}
            />
          </Grid>
        </Grid>
      }
    </>
  )
}

export default WeightStats